/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.base.platform

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import studio.oddpods.cauce.core.base.platform.context.AppContext
import studio.oddpods.cauce.core.base.platform.intent.IntentManagerImpl
import studio.oddpods.cauce.core.base.platform.review.AppReviewManagerImpl
import studio.oddpods.cauce.core.base.platform.update.AppUpdateManagerImpl

@Composable
actual fun LocalManagerProvider(
    context: AppContext,
    content: @Composable () -> Unit,
) {
    CompositionLocalProvider(
        LocalAppReviewManager provides AppReviewManagerImpl(),
        LocalIntentManager provides IntentManagerImpl(),
        LocalAppUpdateManager provides AppUpdateManagerImpl(),
    ) {
        content()
    }
}
